module.exports = __webpack_public_path__ + "static/media/solarSystem.0487da80.mp4";